export const state = {
  regions: [],
  categories: [],
  cities: [],
  tasks: [],
  countries: [],
  directions: [],
}
